export const GET_CLASS = "/fund/:memberId/fetch_class/";
export const EDIT_CLASS = "/fund/:memberId/edit_class/";
